export default __webpack_public_path__ + "static/media/General_Dynamics.29a8bbc7.png";